import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import appUpdate from "@/service/appUpdate";

const app = createApp(App);
app.use(store).use(router);

// 1.0> 追踪运行时错误()
app.config.errorHandler = (err, instance, info) => {
    if (appUpdate.isChunkLoadError(err)) {
        appUpdate.reloadForUpdate(router.currentRoute.value.fullPath);
        return;
    }
    console.error(err); // 错误上报
    console.error(instance);
    console.error(info);
};

// 2.0> 注册全局指令
import directive from "@/service/directive";
app.use(directive, {});

// 3.0> 注册原型方法
// require("/src/service/prototype/index.ts");

// 4.0> 引入Element Plus全局样式
import "element-plus/dist/index.css";

// 5.0> Element Plus国际化（Element Plus默认使用英语，如果希望使用其他语言，需要如下设置）
import ElementPlus from "element-plus";
import zhCn from "element-plus/es/locale/lang/zh-cn";
app.use(ElementPlus, {
    locale: zhCn,
});


// 6.0 引入字体
import "./assets/fonts/fonts.scss";

// 7.0> 注册SVG插件
import "virtual:svg-icons-register";

// 8.0> 引入全局样式（必须放在最后，以便覆盖三方组件的样式）
import "@/assets/css/global-base.scss";
import "@/assets/css/global-page.scss";
import "@/assets/css/theme-light.scss";
import "@/assets/css/theme-dark.scss";
import "@/assets/css/global-function/index.scss";
import "@/assets/css/global-overwrite/index.scss";
import "@/assets/css/tailwind-theme.css";
import "@/assets/css/theme-figma.scss";
import "@/assets/css/aurora-tokens.scss";
import "@/assets/css/animations.css";
import "@/assets/css/dark-mode-decorations.css";
import "@/assets/css/responsive.css";
// 初始化主题：同时设置 .dark/.light class 和 theme 属性（避免闪烁；无缓存默认浅色）
const savedTheme = localStorage.getItem("theme") || localStorage.getItem("vitepress-theme-appearance") || "light";
document.documentElement.setAttribute("theme", savedTheme);
document.documentElement.classList.toggle("dark", savedTheme === "dark");
document.documentElement.classList.toggle("light", savedTheme !== "dark");

app.mount("#app");

if (import.meta.env.PROD) {
    appUpdate.restorePendingRoute(router);
}
